import { ApiService } from '~/shared/api'
import { restGetItem } from '~/shared/utils/decorators'
import type { ServiceRestGetItem } from '~/shared/interfaces'
import { VacancyModel } from '~/model/Vacancy'
import { isUnknownObject } from '~/shared/utils/guards'
import { VacanciesInterlinksService } from '~/services/Vacancies/index'
import { RequestService } from '~/services/RequestService'

interface VacancyService extends ServiceRestGetItem {}

@restGetItem
// eslint-disable-next-line no-redeclare
class VacancyService extends ApiService {
  protected route: string = 'vacancy'
  public vacanciesInterlinks: VacanciesInterlinksService

  constructor(requestService: RequestService) {
    super(requestService)
    this.vacanciesInterlinks = new VacanciesInterlinksService(requestService)
  }

  getItemModel(id: number | string): Promise<VacancyModel> {
    return this.getItem(id).then(({ data }) => {
      const raw = isUnknownObject(data) && isUnknownObject(data.data) ? data.data : null
      return new VacancyModel(raw)
    })
  }
}

export default VacancyService
